import { render, staticRenderFns } from "./LedesDetailList.vue?vue&type=template&id=0a52c7d9&"
import script from "./LedesDetailList.vue?vue&type=script&lang=js&"
export * from "./LedesDetailList.vue?vue&type=script&lang=js&"
import style0 from "./LedesDetailList.vue?vue&type=style&index=0&id=0a52c7d9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports